import { Suspense, lazy, useLayoutEffect } from 'react';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const DashboardPage = lazy(() => import('../pages/DashboardPage'));

/**
 * The home page, for someone signed in: their dashboard (pages/DashboardPage.jsx: the
 * idea box, the tools, what they made last), beside the app's sidebar. A visitor gets the
 * marketing home. Until 2026-10-10 a signed-in arrival was sent to the tool used last
 * instead of the English marketing page (15 signed-in Spanish-browser sessions began on
 * "/" and 4 never reached the app, PostHog 2026-09-30); the dashboard is the app, so the
 * redirect went with the redesign.
 */
export default function HomeForSignedIn({ children }) {
  const { isAuthenticated } = useAuth();
  // index.html marks "/" with the marketing palette's class before the first paint (the
  // marketing home's own hook removes it on unmount); the dashboard is the app, not the site
  useLayoutEffect(() => { if (isAuthenticated) document.documentElement.classList.remove('l3-site'); }, [isAuthenticated]);
  if (!isAuthenticated) return children;
  return (
    <Suspense fallback={<div className="flex min-h-[60vh] items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-muted-foreground" /></div>}>
      <DashboardPage />
    </Suspense>
  );
}
